module.exports = __webpack_public_path__ + "assets/img/privacy-policy.d3993efc.jpg";